<template>
  <v-container class="header-section step">
    <v-row  justify="center" class="full-height">
      <v-col cols='12' class='header-col'>
        <p class="nav-bar">
          <span class="jp" @click="changeLanguage('jp')" :class="{active:isClicked}"><img :src="baseUrl+ '/media/image/japan.png'" alt="renb renb.jp"> <strong style="padding-left:5px">JP</strong></span>
          <span class="line">|</span>
          <span class="vn" @click="changeLanguage('vn')" :class="{active:!isClicked}"><img :src="baseUrl+ '/media/image/vietnam.png'" alt="renb renb.jp"><strong style="padding-left:5px">VN</strong></span>
        </p>
        <v-responsive aspect-ratio="16/9" class="header-video-res">
          <video
              :src="baseUrl + '/media/video/renb_intro.mp4'"
              autoplay
              preload="auto"
              loop
              playsinline
              style="width:100%; height: 100%; object-fit: contain;"
               data-aos="zoom-in"
              muted >
          </video>
         </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  created () {
    console.log('Base URL:', process.env.VUE_APP_BASE_URL)
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      isClicked: true
    }
  },
  methods: {
    changeLanguage (lang) {
      lang === 'jp' ? this.isClicked = true : this.isClicked = false
      this.$i18n.locale = lang
    }
  }
}
</script>

<style scoped>
.step {
  height: 100vh!important;
  display: flex;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;
}
.header-section {
  padding: 0px!important;
}
.header-col {
  width: 100%; /* Chiều rộng của div */
  height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-direction: column;

}
.nav-bar {
  width: 100%;
  margin-top: 20px;
  margin-left: 5px;
  font-family: "ZenKakuRegular";
  display: inline-flex;
  align-content: center;
}
.line {
  font-size: 20px;
  padding: 0;
}
.jp {
  padding-right: 5px;
}
.vn {
  padding-left: 5px;
}
.jp,
.vn {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.vn img {
  width: 28px;
}
.active {
  text-decoration: underline;
  color: brown;
}
@media (max-width: 1200px) {
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
  }
  .header-col {
    display: unset;
    padding-top: unset!important;
  }
  .full-height {
    padding-top: unset;
    height: unset!important;
  }

}
@media (max-width: 600px) {
  .header-col {
    padding: 0px!important;
  }
}
</style>
